import React from 'react';

import { PaywallScreens } from '~analytics/types';
import { translate } from '~l10n/client';
import { QuizEditorFileUploadPaywall } from '~teacher/components/QuizEditor/QuizEditorFileUploadPaywall';

import { generateQuestionPaywallAtom } from './atom';

export function GenerateQuestionPaywall() {
  return (
    <QuizEditorFileUploadPaywall
      id="paywall-generate-questions"
      title={translate('Upgrade to Generate Questions from Document')}
      description={translate(
        'Enhance your AI-generated questions by uploading documents like worksheets, reports, and learning materials.'
      )}
      paywallScreen={PaywallScreens.QuizEditGenerateQuestionsWithFileUpload}
      paywallAtom={generateQuestionPaywallAtom}
    />
  );
}
